export default __webpack_public_path__ + "static/media/drain logos.a5bd7e80.png";